import compose from "ramda/es/compose";
import ifElse from "ramda/es/ifElse";
import join from "ramda/es/join";
import mapObjIndexed from "ramda/es/mapObjIndexed";
import values from "ramda/es/values";
import isFunction from "ramda-extension/es/isFunction";
import { CONTENT_TYPE_HEADER, METHOD } from '../../../constants';
import { curriedApi } from '../../../facade';
const transformToQueryString = compose(join('&'), values, mapObjIndexed((value, key)=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`));
/**
 * Method = POST
 * Headers = application/x-www-form-urlencoded
 * BodyManipulation = transformToQueryString(body)
 *
 *
 * @param {object} {endpoint, body, actions[{}], additionalHeaders[{}], credentials}
 * @return {Promise} promise
 */ export default curriedApi(METHOD.POST, {
    headers: CONTENT_TYPE_HEADER.APPLICATION_X_WWW_FORM_URLENCODED,
    bodyManipulation: ifElse(isFunction, compose(transformToQueryString), transformToQueryString)
});
